import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import MicrochipInputView from "@/views/microchip/MicrochipInputView.vue";
import MicrochipResultView from "@/views/microchip/MicrochipResultView.vue";
import GeneticIdInputView from "@/views/geneticId/GeneticIdInputView.vue";
import GeneticIdResultView from "@/views/geneticId/GeneticIdResultView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/microchip",
    redirect: "/microchip/Input",
  },
  {
    path: "/microchip/input",
    name: "microchipInput",
    component: MicrochipInputView,
  },
  {
    path: "/microchip/result",
    name: "microchipResult",
    component: MicrochipResultView,
  },
  {
    path: "/geneticId",
    redirect: "/geneticId/input",
  },
  {
    path: "/geneticId/input",
    name: "geneticIdInput",
    component: GeneticIdInputView,
  },
  {
    path: "/geneticId/result",
    name: "geneticIdResult",
    component: GeneticIdResultView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
